<template>
  <div class="container valign-wrapper full">
    <ul class="collection center users">
      <li class="collection-item" v-for="(u, _) in users" :key="_" v-if="users.length > 0" >
          {{ u.username }}
          <a href="#!" class="secondary-content grey-text" @click="remove(u.id)" v-if="$store.claims.users & 2"><i class="material-icons">delete</i></a>
      </li>
      <li class="collection-item" v-if="users.length == 0 && this.$store.claims.users & 1">
          No users have been added yet!
      </li>
      <li class="collection-item" v-if="$store.claims.users & 2">
          <a href="#" class="btn" @click="showUserCreation()">Add user</a>
      </li>
    </ul>
    <div id="create-user" class="modal">
      <div class="modal-content">
        <h4>Create new user</h4>
        <p>Create a new user to allow them to access the Helen management console.</p>
        <form class="form">
          <div class="row">
            <div class="input-field col s12">
              <input id="username" type="text" v-model="username">
              <label for="username">Username</label>
            </div>
            <div class="input-field col s12">
              <input id="password" type="password" v-model="password">
              <label for="password">Password</label>
            </div>
            <div class="input-field col s12">
              <input id="passwordConfirm" type="password" v-model="passwordConfirm">
              <label for="passwordConfirm">Confirm password</label>
            </div>
            <b>Permissions</b>
            <ul class="collection">
                <li class="collection-item">
                    Languages
                    <div class="switch right" :disabled="permissions.addDevices" v-if="permissions.languages.read">
                        <label>
                        Only read    
                        <input type="checkbox" :disabled="permissions.addDevices" v-model="permissions.languages.write" v-on:change="updateRequirements()">
                        <span class="lever"></span>
                        Read & Write
                        </label>
                    </div>
                </li>
                <li class="collection-item">
                    <label>
                        <input type="checkbox" :disabled="permissions.addDevices" class="filled-in" v-model="permissions.phrases.read" v-on:change="updateRequirements()" />
                        <span>Phrases</span>
                    </label>
                    <div class="switch right" v-if="permissions.phrases.read">
                        <label>
                        Only read
                        <input type="checkbox" :disabled="permissions.addDevices" v-model="permissions.phrases.write" v-on:change="updateRequirements()">
                        <span class="lever"></span>
                        Read & write
                        </label>
                    </div>
                </li>
                <li class="collection-item">
                    <label>
                        <input type="checkbox" :disabled="permissions.addDevices" class="filled-in" v-model="permissions.dialogs.read" v-on:change="updateRequirements()" />
                        <span>Dialogs</span>
                    </label>
                    <div class="switch right" v-if="permissions.dialogs.read">
                        <label>
                        Only read    
                        <input type="checkbox" :disabled="permissions.addDevices" v-model="permissions.dialogs.write" v-on:change="updateRequirements()">
                        <span class="lever"></span>
                        Read & Write
                        </label>
                    </div>
                </li>
                <li class="collection-item">
                    <label>
                        <input type="checkbox" class="filled-in" :disabled="permissions.addDevices" v-model="permissions.settings.read" v-on:change="updateRequirements()" />
                        <span>Settings</span>
                    </label>
                    <div class="switch right" v-if="permissions.settings.read">
                        <label>
                        Only read    
                        <input type="checkbox" :disabled="permissions.addDevices" v-model="permissions.settings.write" v-on:change="updateRequirements()">
                        <span class="lever"></span>
                        Read & Write
                        </label>
                    </div>
                </li>
                <li class="collection-item">
                    <label>
                        <input type="checkbox" class="filled-in" v-model="permissions.users.read" v-on:change="updateRequirements()" />
                        <span>Users</span>
                    </label>
                    <div class="switch right" v-if="permissions.users.read">
                        <label>
                        Only read    
                        <input type="checkbox" v-model="permissions.users.write" v-on:change="updateRequirements()">
                        <span class="lever"></span>
                        Read & Write
                        </label>
                    </div>
                </li>
                <li class="collection-item">
                    <label>
                        <input type="checkbox" class="filled-in" v-model="permissions.addDevices" v-on:change="updateRequirements()" />
                        <span>Add new devices (user will be allowed to grant permissions)</span>
                    </label>
                </li>
            </ul>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <a href="#!" class="modal-action modal-close waves-effect waves-green btn-flat">Close</a>
        <a href="#!" class="modal-action waves-effect waves-green btn-flat" @click="addUser()">Add user</a>
      </div>
    </div>
  </div>
</template>
<style scoped>
.full{
    height: 100vh;
}
.center{
    margin:auto;
}
.users{
    min-width: 300px;
}
#create-user{
    max-width: 600px;
    top: 3% !important;
}
.modal{
    top: 2%;
    max-height: 98%;
}
</style>
<script>
  export default {
    name: 'users',
    data() {
      return {
        users: [],
        username: "",
        password: "",
        passwordConfirm: "",
        permissions: {
            phrases: {
                read: false,
                write: false
            },
            dialogs: {
                read: false,
                write: false
            },
            languages: {
                read: true,
                write: false
            },
            users: {
                read: false,
                write: false
            },
            settings: {
                read: false,
                write: false
            },
            addDevices: false,
        }
      }
    },
    methods: {
        update(){
            this.$http
            .get("/auth/users")
            .then(r => {
                this.users = r.data.filter(x => x.username !== "admin")
                this.$store.users = r.data
            })
            .catch(r => {
                M.toast({html: r.data})
            }); 
        },
        getFlag(claim) {
            return (claim.read ? 1 : 0) + (claim.write ? 2 : 0)
        },
        updateRequirements() {
            if(this.permissions.dialogs.write){
                this.permissions.phrases.read = true;
            }
            if(!this.permissions.dialogs.read){
                this.permissions.dialogs.write = false;
            }
            if(!this.permissions.users.read){
                this.permissions.users.write = false;
            }
            if(!this.permissions.phrases.read){
                this.permissions.phrases.write = false;
            }
            if(this.permissions.addDevices){
                this.permissions.phrases.read = true;
                this.permissions.phrases.write = true;
                this.permissions.languages.read = true;
                this.permissions.languages.write = true;
                this.permissions.dialogs.read = true;
                this.permissions.dialogs.write = true;
                this.permissions.settings.read = true;
                this.permissions.settings.write = true;
            }
        },
        addUser(){
            if(this.password !== this.passwordConfirm){
                M.toast({html: "Passwords does not match"})
                return
            }
            this.$http
            .post("/auth/users", {username: this.username, password: this.password, claims: { 
                "phrases": this.getFlag(this.permissions.phrases) + (this.permissions.addDevices == true ? 4 : 0),
                "dialogs": this.getFlag(this.permissions.dialogs) + (this.permissions.addDevices == true ? 4 : 0),
                "languages": this.getFlag(this.permissions.languages) + (this.permissions.addDevices == true ? 4 : 0),
                "settings": this.getFlag(this.permissions.settings) + (this.permissions.addDevices == true ? 4 : 0),
                "users": this.getFlag(this.permissions.users),
                "stats": this.permissions.addDevices == true ? 6 : 0
            }})
            .then(r => {
                this.update()
                M.Modal.getInstance(this.$el.querySelector("#create-user")).close();
            }).catch(r => {
                M.toast({html: r.data})
            }); 
        },
        remove(id){
            this.$http
            .delete("/auth/users/" + id)
            .then(r => {
                this.update()
                M.toast({html: "User was removed"})
            }).catch(r => {
                M.toast({html: r.data})
            }); 
        },
        showUserCreation(){
            M.Modal.getInstance(this.$el.querySelector("#create-user")).open();
        }
    },
    mounted() {
        this.$el.querySelectorAll(".modal").forEach(e => M.Modal.init(e, {}));
        this.$el.querySelectorAll('select').forEach(x => M.Select.init(x, {}));
    },
    created() {
      this.update()
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/Users.vue